import React, { useState } from 'react';
import { CssBaseline } from '@mui/material';
import { AnimatePresence } from 'framer-motion';
import './styles/global.css';

import AnimatedIntro from './components/AnimatedIntro/AnimatedIntro';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import Intro from './components/Intro/Intro';
import Services from './components/Services/Services';
import Gallery from './components/Gallery/Gallery';
import Events from './components/Events/Events';
import Stats from './components/Stats/Stats';
import Testimonials from './components/Testimonials/Testimonials';
import FAQ from './components/FAQ/FAQ';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';

const App: React.FC = () => {
  const [introDone, setIntroDone] = useState(false);
  const [contactOpen, setContactOpen] = useState(false);

  const openContact = () => setContactOpen(true);

  return (
    <>
      <CssBaseline />
      <AnimatePresence>
        {!introDone && <AnimatedIntro onComplete={() => setIntroDone(true)} />}
      </AnimatePresence>
      <Header onOpenContact={openContact} />
      <main>
        <Hero onOpenContact={openContact} />
        <Intro />
        <Services />
        <Gallery />
        <Events onOpenContact={openContact} />
        <Stats />
        <Testimonials />
        <FAQ />
      </main>
      <Footer onOpenContact={openContact} />
      <Contact open={contactOpen} onClose={() => setContactOpen(false)} />
    </>
  );
};

export default App;
